<template>
	<v-container>
	  <v-row>
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="mt-4">
			<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
				{{ tituloExamen.titulo }} <br>
				<v-chip color="error" v-if="tituloExamen.recuperacion">Recuperación</v-chip>
			</div> 
	  	</v-col>

	  	<v-col cols="12" v-if="ejercicioResuelto">
			<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
				Calificación: {{ calificacion }}
			</div>
	  	</v-col>
	  </v-row>

	  <v-row justify="center" v-for="(pregunta, i ) in preguntas" :key="i">
	  	<v-col cols="12" md="8" lg="6">
	  		<v-card class="shadowCard px-0">
	  		  <v-card-title primary-title class="grey--text text-body-1">
	  		    Pregunta {{ pregunta.num_pregunta }}
	  		    <v-spacer></v-spacer>
	  		    Valor {{ pregunta.valor }}
	  		  </v-card-title>
	  		  <v-img 
	  		  	v-if="pregunta.tiene_imagen == 1" 
	  		  	:src="url + pregunta.ruta_imagen"
	  		 	></v-img>
	  		 	<div v-if="pregunta.tiene_audio_pregunta == 1" class="text-center mt-2 pb-0">
	  		 		<audio controls>
						  <source :src="url + pregunta.ruta_audio_pregunta" type="audio/mpeg"></audio>
						</audio>
	  		 	</div>
	  		 	
	  		 	<v-card-text class="text-center pt-0">
				    <v-chip-group
			        v-model="pregunta.eleccion"
			        active-class="primary--text text--accent-4"
			        column
							required
							v-if="!ejercicioResuelto"
			      >
			        <v-chip :value="1">
			          a) {{ pregunta.valor1 }}
			        </v-chip>

			        <v-chip :value="2">
			          b) {{ pregunta.valor2 }}
			        </v-chip>

			        <v-chip :value="3">
			          c) {{ pregunta.valor3 }}
			        </v-chip>

			        <v-chip :value="4">
			          d) {{ pregunta.valor4 }}
			        </v-chip>
			      </v-chip-group>

			      <v-chip-group
							v-else
			        column
			      >
			      	<!-- Pregunta 1 -->
			        <v-chip
			        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 1 || pregunta.respuesta == 1 && pregunta.eleccion != 1"
			        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 1 ? 'green': ''"
			        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 1 ? true : false ">
			          a) {{ pregunta.valor1 }}
			          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 1">mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 1"
			        	color="red" dark>
			          a) {{ pregunta.valor1 }} <v-icon small right>mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 1"
			        	color="primary">
			          a) {{ pregunta.valor1 }} <v-icon small right>mdi-close</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 1 && pregunta.correcta != 1"
			        >
			          a) {{ pregunta.valor1 }}
			        </v-chip>

			      	<!-- Pregunta 2 -->
			        <v-chip
			        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 2 || pregunta.respuesta == 1 && pregunta.eleccion != 2"
			        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 2 ? 'green': ''"
			        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 2 ? true : false ">
			          b) {{ pregunta.valor2 }}
			          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 2">mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 2"
			        	color="red" dark>
			          b) {{ pregunta.valor2 }} <v-icon small right>mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 2"
			        	color="primary">
			          b) {{ pregunta.valor2 }} <v-icon small right>mdi-close</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 2 && pregunta.correcta != 2"
			        >
			          b) {{ pregunta.valor2 }}
			        </v-chip>

			      	<!-- Pregunta 3 -->
			        <v-chip
			        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 3 || pregunta.respuesta == 1 && pregunta.eleccion != 3"
			        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 3 ? 'green': ''"
			        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 3 ? true : false ">
			          c) {{ pregunta.valor3 }}
			          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 3">mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 3"
			        	color="red" dark>
			          c) {{ pregunta.valor3 }} <v-icon small right>mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 3"
			        	color="primary">
			          c) {{ pregunta.valor3 }} <v-icon small right>mdi-close</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 3 && pregunta.correcta != 3"
			        >
			          c) {{ pregunta.valor3 }}
			        </v-chip>

			      	<!-- Pregunta 4 -->
			        <v-chip
			        	v-if="pregunta.respuesta == 1 && pregunta.eleccion == 4 || pregunta.respuesta == 1 && pregunta.eleccion != 4"
			        	:color=" pregunta.respuesta == 1 && pregunta.eleccion == 4 ? 'green': ''"
			        	:dark=" pregunta.respuesta == 1 && pregunta.eleccion == 4 ? true : false ">
			          d) {{ pregunta.valor4 }}
			          <v-icon small right v-if="pregunta.respuesta == 1 && pregunta.eleccion == 4">mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.correcta == 4"
			        	color="red" dark>
			          d) {{ pregunta.valor4 }} <v-icon small right>mdi-check</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion == 4"
			        	color="primary">
			          d) {{ pregunta.valor4 }} <v-icon small right>mdi-close</v-icon>
			        </v-chip>

			        <v-chip
			        	v-if="pregunta.respuesta == 0 && pregunta.eleccion != 4 && pregunta.correcta != 4"
			        >
			          d) {{ pregunta.valor4 }}
			        </v-chip>

			      </v-chip-group>

	  		 	</v-card-text>		
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-row justify="center">
	  	<!-- El boton solo debe aparecer siempre y cuando no haya contestado el ejercicio -->
	  	<v-col cols="12" md="8" lg="6" v-if="!ejercicioResuelto">
	  		<v-card-actions>
	  			<v-btn class="btn-grad text-capitalize" rounded 
	  				large 
	  				dark 
	  				block 
	  				@click="enviarRespuesta()" 
	  				:disabled="disabled"
	  				:loading="loading"
	  			>
	  				<span v-if="!respuestaEnviada">Enviar respuestas</span>
	  				<span v-else>Respuestas enviadas</span>
	  			</v-btn>
	  		</v-card-actions>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          @click="verRecursos()"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	valid: true,
	  	rules: {
        required: value => !!value || 'Requerido.'
      },

	  	url: '',
	  	show: false,
     	preguntas:[],

     	selection: 0,

     	disabled: false,
     	loading: false,
     	respuestaEnviada: false,

     	loader: true,
      	cargar: false,
		parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	respuestaAlerta: false,

     	calificacion: 0,
     	calificaciontotal:0,
     	ejercicioResuelto: false,

		tituloExamen : {
			id: 0,
			titulo: 'Examen',
			recuperacion: 0
		}

	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ])
	  },

	  created(){
	  	if(this.getRecursosGrupoUsuario.length > 0){
	  		this.url = this.getRecursosGrupoUsuario[0].ubicacion
	  	}
		  if(this.getRecurso[0].recurso.includes('medio termino')){
			this.tituloExamen.id = 1
			this.tituloExamen.titulo = 'Examen de medio termino'
			this.tituloExamen.recuperacion = 0
		}
		if(this.getRecurso[0].recurso.includes('final')){
			this.tituloExamen.id = 2
			this.tituloExamen.titulo = 'Examen final'
			this.tituloExamen.recuperacion = 0
		}
		if(this.getRecurso[0].recurso.includes(' recuperacion')){
			this.tituloExamen.recuperacion = 1
		}

	  	this.initialize ()
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso'] ),

	  	initialize ( ){
	  		this.cargar = true
	  		// Guardamos el id de la evaluacion
		  	const id_evaluacion = this.getRecurso[0].id_evaluacion

		  	const payload = {
		  		id_evaluacion,
		  		id_usuario: this.getUsuarioLMS.id,
		  		id_grupo:   this.getGrupo.grupo.id
		  	}

		  	// Hacer la ptetición
		  	this.$http.post('recurso.resuelto', payload).then(response => {
		  		this.ejercicioResuelto = response.body.ejercicioResuelto
		  		this.preguntas         = response.body.preguntas
		  		this.calificaciontotal = response.body.calificaciontotal
		  		this.calificacion      = response.body.recursoRescuelto.calificacion
		  		this.idResultado       = response.body.recursoRescuelto.id
		  		this.disabled = false
		  		this.loading  = false
		  		this.cargar   = false
		  	}).catch( error =>{
		  		this.validarErrores ( error )
	  		}).finally( () => { this.cargar = false })

		  	this.preguntas.evaluacion = []
	  	},

	  	validarDatos () {
	  		this.calificacion = 0
	  		for( const i in this.preguntas){
	  			let { eleccion, num_pregunta, respuesta, opcion_correcta, valor } = this.preguntas[i]
	  			if( !eleccion ){ 
	  				this.parametros.mensaje      = 'Por favor, contesta la pregunta #' + num_pregunta
	  				this.parametros.color        = '#FF2C2C'
      			this.parametros.dialogError  = true 
      			this.respuestaAlerta = true 
	  				return false 
	  			}

	  			if( eleccion == opcion_correcta ){ this.preguntas[i].respuesta = 1; this.calificacion += valor}
	  			else{ this.preguntas[i].respuesta = 0 }

	  		}
	  		return true
      },

	  	enviarRespuesta( ){
	  		if( this.validarDatos() ){
		  		const payload = {
		  			id_alumno:         this.getUsuarioLMS.id,
		  			id_grupo:          this.getGrupo.grupo.id,
		  			id_curso:          this.getGrupo.grupo.id_curso,
		  			id_nivel:          this.getGrupo.grupo.id_nivel,
		  			id_ciclo:          this.getGrupo.grupo.id_ciclo,
		  			session:           this.getRecurso[0].id_leccion,
		  			id_evaluacion:     this.getRecurso[0].id_evaluacion,
		  			calificacion:      this.calificacion,
		  			calificaciontotal: this.calificaciontotal,
		  			preguntas:         this.preguntas
		  		}

		  		this.disabled = true
		  		this.loading  = true
		  		this.cargar   = true

		  		// Hacer la ptetición
		  		this.$http.post('recurso.contestar', payload).then(response => {
			  		this.parametros.mensaje      = 'Ejercicio Realizado'
	  				this.parametros.color        = 'success'
	    			this.parametros.dialogError  = true 
	    			this.respuestaAlerta = true 
			  		this.initialize()
			  	}).catch( error =>{
			  		this.disabled = false
			  		this.loading  = false
			  		this.cargar   = false
			  		this.validarErrores ( error )
		  		}).finally( () => { this.cargar = false })
		  	}
	  	},

	  	verRecursos ( ){
	  		this.cargar = true
	  		const payload = {
					id_usuario: this.getUsuarioLMS.id, 
					id_curso:   this.getGrupo.grupo.id_curso,
					id_nivel:   this.getGrupo.grupo.id_nivel,
					id_grupo:   this.getGrupo.grupo.id,
					lecciones:  this.getGrupo.info_curso.dias_clase,
					tipo:       this.getGrupo.grupo.tipo
	  		}

	  		this.abrirRecursosAlumno( payload ).then(response => { 
	  			this.cargar = false
	  		}).catch( error =>{
    			this.validarErrores ( error )
    		}).finally( () => { this.cargar = false })
	  	},

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
    		}
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}

	.v-expansion-panel-content__wrap{
		padding-right: 0px !important;
		padding-left: 0px !important;
	}



	.btn-grad {
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}
         
        
         
</style>
